import { render, staticRenderFns } from "./TopSalesItems.vue?vue&type=template&id=51d89b1a"
import script from "./TopSalesItems.vue?vue&type=script&lang=js"
export * from "./TopSalesItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports